module.exports = __webpack_public_path__ + "img/holz.39c34cbf.png";